export const CDN_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

// export const SWIGGY_URL = "https://corsproxy.org/?https%3A%2F%2Fwww.swiggy.com%2Fdapi%2Frestaurants%2Flist%2Fv5%3Flat%3D22.6263806%26lng%3D88.3555025%26is-seo-homepage-enabled%3Dtrue%26page_type%3DDESKTOP_WEB_LISTING"

// export const SWIGGY_URL_MENU = "https://corsproxy.org/?https%3A%2F%2Fwww.swiggy.com%2Fdapi%2Fmenu%2Fpl%3Fpage-type%3DREGULAR_MENU%26complete-menu%3Dtrue%26lat%3D22.6263806%26lng%3D88.3555025%26restaurantId%3D"



export const SWIGGY_URL = "https://www.swiggy.com/dapi/restaurants/list/v5?lat=22.6263806&lng=88.3555025&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING"

export const SWIGGY_URL_MENU = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=22.6263806&lng=88.3555025&restaurantId=258735&catalog_qa=undefined&isMenuUx4=true&submitAction=ENTER"
